<script>
  import SideBarPage from '../components/SideBarPage'
  import Start from '../components/statistics/Start'
  import Circus from '../components/statistics/Circus'
  import Dancers from '../components/statistics/Dancers'
  import Musicians from '../components/statistics/Musicians'

  export default {
    name: 'statistics',
    render(h) {
      return h('side-bar-page', [
        h(this.getTag(),{'slot': 'content'})
      ]);
    },
    components: { SideBarPage, Start, Circus, Dancers, Musicians },
    watch: {
      '$route'() {
        // обрабатываем изменение параметров маршрута...
        this.$forceUpdate(); // Запуск отрисовки
      }
    },
    methods: {
      getTag() {
        const types = ['circus', 'dancers', 'musicians'];
        let res = 'start';
        if(this.$route.params.type) {
          if(types.find(i=>i==this.$route.params.type)) {
            res = this.$route.params.type;
          } else {
            this.$router.push({name: 'statistics'});
          }
        }
        return res;
      }
    }
  }
</script>

<style scoped>

</style>
